import { Star } from "./motion";

const Marquee = ({ items, dark = true, reverse = false, testId = "marquee" }) => (
  <div
    data-testid={testId}
    className={`overflow-hidden border-b-2 border-ink py-3 ${
      dark ? "bg-ink text-paper" : "bg-rust text-paper"
    }`}
    aria-hidden="true"
  >
    <div className={`flex w-max animate-marquee ${reverse ? "marquee-reverse" : ""}`}>
      {[0, 1].map((half) => (
        <div key={half} className="flex shrink-0 items-center">
          {items.map((t, i) => (
            <span
              key={i}
              className="flex items-center gap-8 whitespace-nowrap px-8 font-display text-2xl uppercase tracking-wide sm:text-3xl"
            >
              {t}
              <Star size={18} className={i % 2 === 0 ? (dark ? "fill-rust" : "fill-paper") : "fill-polered"} />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
